/*eslint-disable*/
import React, { useState, useEffect } from "react";
import {
  TextField,
  Typography,
  Divider,
  Paper,
  Grid,
  FormControlLabel,
  Radio,
  RadioGroup,
  Box,
} from "@mui/material";
import CustomDropDownPicker from "../../../components/CustomDropDownPicker";
import { STYLES } from "config";

function OwnerDetailsComponent(props) {
  const { data, setvalue } = props;
  const [state, setstate] = useState(data);

  useEffect(() => {
    setstate(data);
  }, [data]);

  const updateData = (e) => {
    const updatedState = { ...state, [e.target.name]: e.target.value };
    setstate(updatedState);
    setvalue(updatedState);
    console.log("updatedState", updatedState);
  };

  const updateDataNested = (e) => {
    const { name, value } = e.target;
    const keys = name.split("."); // Split name by '.' to access nested fields
    const updatedState = { ...state };

    let current = updatedState;
    for (let i = 0; i < keys.length - 1; i++) {
      current = current[keys[i]] = current[keys[i]] || {};
    }
    current[keys[keys.length - 1]] = value;

    setstate(updatedState);
    setvalue(updatedState);
    console.log("updatedState", updatedState);
  };

  const handleDropdownChange = (name, value) => {
    const keys = name.split(".");
    const updatedState = { ...state };

    let current = updatedState;
    for (let i = 0; i < keys.length - 1; i++) {
      current = current[keys[i]] = current[keys[i]] || {};
    }
    current[keys[keys.length - 1]] = value;

    setstate(updatedState);
    setvalue(updatedState);
  };

  // Dropdown options
  const sellerTitleOptions = [
    { label: "Mr", value: "Mr" },
    { label: "Ms", value: "Ms" },
    { label: "Mrs", value: "Mrs" },
    { label: "Dr", value: "Dr" },
    { label: "Prof", value: "Prof" }
  ];

  const ownershipTypeOptions = [
    { label: "Individual", value: "Individual" },
    { label: "Company", value: "Company" }
  ];

  return (
     <Paper elevation={5} sx={{ p: 3 }}>
    <Box sx={{ p: 2 }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 400,
          mb: 1,
          color: STYLES.WEB_APP_FONT_CLR
        }}
      >
        Owner Details
      </Typography>

      <Divider sx={{ borderColor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

      <Paper elevation={0} sx={{ p: 2, mb: 2 }}>
        <Typography variant="body1">
          Complete the Owner's details.
        </Typography>
      </Paper>

      <Divider sx={{ borderColor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Seller Title :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <CustomDropDownPicker
            options={sellerTitleOptions}
            value={data?.seller?.sellerTitle || ""}
            onChange={(value) =>
              handleDropdownChange("seller.sellerTitle", value)
            }
            placeholder="Select Seller Title"
            style={{
              borderColor: "#003366",
              color: STYLES.WEB_APP_FONT_CLR
            }}
          />
        </Grid>

        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Name and Surname :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <TextField
            fullWidth
            name="seller.entityName"
            size="small"
            value={data?.seller?.entityName ? data?.seller?.entityName : data?.seller?.ownername || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Home Tel :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <TextField
            fullWidth
            name="seller.homeTel"
            size="small"
            value={data?.seller?.homeTel || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Seller Ownership Type :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <CustomDropDownPicker
            options={ownershipTypeOptions}
            value={data?.seller?.sellerownershipType || ""}
            onChange={(value) =>
              handleDropdownChange("seller.sellerownershipType", value)
            }
            placeholder="Select Ownership Type"
            style={{
              borderColor: "#003366",
              color: STYLES.WEB_APP_FONT_CLR
            }}
          />
        </Grid>

        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Entity No. :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <TextField
            fullWidth
            name="seller.entityNo"
            size="small"
            value={data?.seller?.entityNo || data?.seller?.entityName || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Seller Postal Address :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <TextField
            fullWidth
            name="seller.postalAddress"
            size="small"
            value={data?.seller?.postalAddress || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Email :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <TextField
            fullWidth
            name="seller.email"
            size="small"
            type="email"
            value={data?.seller?.email || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Fax :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <TextField
            fullWidth
            name="seller.fax"
            size="small"
            type="number"
            value={data?.seller?.fax || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Cell :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <TextField
            fullWidth
            name="seller.cellTel"
            size="small"
            value={data?.seller?.cellTel || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Work Tel :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <TextField
            fullWidth
            name="seller.workTel"
            size="small"
            type="number"
            value={data?.seller?.workTel || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Seller Entity Name :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <TextField
            fullWidth
            name="seller.entityName"
            size="small"
            value={data?.seller?.entityName || data?.seller?.company|| ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            VAT Vendor (Y/N) :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <RadioGroup
            row
            name="seller.vatVendor"
            value={data?.seller?.vatVendor || ""}
            onChange={updateDataNested}
          >
            <FormControlLabel value="YES" control={<Radio />} label="YES" />
            <FormControlLabel value="NO" control={<Radio />} label="NO" />
          </RadioGroup>
        </Grid>

        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            VAT Number :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <TextField
            fullWidth
            name="seller.vatNumber"
            size="small"
            value={data?.seller?.vatNumber || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2} sm={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Entity Postal Address :
          </Typography>
        </Grid>
        <Grid item size={10} sm={10}>
          <TextField
            fullWidth
            name="seller.postalAddress"
            size="small"
            value={data?.seller?.postalAddress || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>
      </Grid>
    </Box>
    </Paper>
  );
}

export default OwnerDetailsComponent;
